import styled, { keyframes } from "styled-components";
import { popUpIndex } from "../../config/zIndex";
import { fadeInDown } from "react-animations";

// Keyframes
const fadeInDownAnimation = keyframes`${fadeInDown}`;

export const PopUpBackground = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: ${popUpIndex};
`;
export const PopUpContainer = styled.div`
  padding: 20px;
  width: 100%;
  max-width: 860px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 5px;
  animation: 0.4s ${fadeInDownAnimation};
  @media (max-width: 910px) {
    width: 85%;
  }
`;
export const TitleAndCloseDiv = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const ProtocolTitle = styled.p`
  font-weight: bold;
`;
export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;
`;
export const CloseImg = styled.img`
  width: 30px;
  height: 30px;
`;
export const ProtocolVideoIframe = styled.iframe`
  margin: 20px 0;
  width: 100%;
  aspect-ratio: 16 / 9;
  border: none;
  border-radius: 5px;
`;
export const DescriptionText = styled.p`
  font-size: 14px;
`;
export const DescriptionTitle = styled.span`
  font-size: 14px;
  font-weight: bold;
`;
